<template>
  <info-form>
    <ButtonUpdate class="mt_m"/>
    <ButtonDelete class="mt_s"/>
  </info-form>
</template>

<script>
import InfoForm from '@/components/Info/Form'
import ButtonUpdate from '@/components/Info/ButtonUpdate'
import ButtonDelete from '@/components/Info/ButtonDelete'

export default {
  components: {
    InfoForm,
    ButtonUpdate,
    ButtonDelete
  },
  created: async function () {
    await this.$store.dispatch(
      'info/getInfo',
      this.$route.params.id
    )
    this.$store.dispatch('info/initForm')
  }
}
</script>
